import { Routes } from '@angular/router';
import { mainLayoutRoutes } from './@commons/layouts/main-layout.routes'; // Import Routes from Angular Router

// Define application routes using lazy loading for feature modules
export const routes: Routes = [
  {
    path: 'splashScreen', // Path for the splash screen
    loadChildren: () =>
      import('./@commons/ui-components/splash-screen/splash-screen.routes'), // Lazy load splash screen routes
  },
  {
    path: 'onboarding', // Path for onboarding
    loadChildren: () => import('./onboarding/onboarding.routes'), // Lazy load onboarding routes
  },
  {
    path: 'auth', // Path for authentication module
    loadChildren: () => import('./auth/auth.routes'), // Lazy load authentication routes
  },
  {
    path: 'oauth2', // Path for authentication module
    loadChildren: () => import('./auth/oauth2.routes'), // Lazy load authentication routes
  },
  {
    path: 'init', // Path for the welcome page
    loadChildren: () => import('./welcome/welcome.routes'), // Lazy load welcome routes
  },
  {
    path: 'article/:articleUid', // Path for article module
    loadComponent: () => import('./article/article.component').then((m) => m.ArticleComponent), // Lazy load article routes
  },
  {
    path: 'qr/plant/:uid', // Public page for QR code fallback
    loadComponent: () => import('./qr/plant-landing/plant-landing.component').then((m) => m.PlantLandingComponent),
  },
  {
    path: 'feedback', // Path for feedback module
    loadComponent: () => import('./feedback/feedback.component').then((m) => m.FeedbackComponent), // Lazy load feedback routes
  },
  {
    path: 'notifications',
    loadComponent: () => import('./notifications/notifications.component').then((m) => m.NotificationsComponent),
  },
  {
    path: '',
    redirectTo: 'home', // Default route redirects to 'home'
    pathMatch: 'full',
  },
  ...mainLayoutRoutes, // Include main layout routes here
  {
    path: 'garden', // Path for potager routes
    loadChildren: () =>
      import('./garden/garden.module').then((m) => m.GardenModule), // Ensure correct import path
  },
  {
    path: '**',
    redirectTo: 'home', // Global fallback route to splashScreen
  },
];
